import React from "react";
import { useAuthUser } from "react-auth-kit";

// Example role checking function
export function CheckRole(role) {
    const auth = useAuthUser();
    return auth()?.user?.roles?.some((r) => r?.name === role) ?? false;
}

// Authorization component
const CheckAuthorization = ({ roles = [], children }) => {
    const isAuthorized = Array.isArray(roles)
        ? roles.some((role) => CheckRole(role))
        : false;

    if (!isAuthorized) {
        return null;
    }

    return <>{children}</>;
};

export default CheckAuthorization;